import React, { useEffect, useRef, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from './images/logo-2.png';

const NetflixTitle = () => {
  const [isMounted, setIsMounted] = useState(false);
  const navigate = useNavigate();
  const navigateTimerRef = useRef<number | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const hasPlayedSoundRef = useRef(false);

  const scheduleNavigation = (delayMs: number) => {
    if (navigateTimerRef.current !== null) {
      window.clearTimeout(navigateTimerRef.current);
    }

    navigateTimerRef.current = window.setTimeout(() => {
      navigate('/browse');
    }, delayMs);
  };

  const playSound = () => {
    if (!audioRef.current || hasPlayedSoundRef.current) return;

    audioRef.current.currentTime = 0;
    audioRef.current.muted = false;
    audioRef.current.volume = 1;
    audioRef.current
      .play()
      .then(() => {
        hasPlayedSoundRef.current = true;
      })
      .catch(error => {
        console.error('Audio play error:', error);
      });
  };

  useEffect(() => {
    audioRef.current = new Audio(netflixSound);
    audioRef.current.preload = 'auto';
    audioRef.current.autoplay = false;
    audioRef.current.setAttribute('playsinline', 'true');
    audioRef.current.muted = false;
    audioRef.current.volume = 1;
    audioRef.current.load();

    requestAnimationFrame(() => setIsMounted(true));
    scheduleNavigation(5200);

    return () => {
      if (navigateTimerRef.current !== null) {
        window.clearTimeout(navigateTimerRef.current);
      }

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }

      navigateTimerRef.current = null;
    };
  }, [navigate]);

  const handleUserGesture = () => {
    playSound();
  };

  return (
    <div
      className="netflix-container"
      onPointerDown={handleUserGesture}
      onMouseDown={handleUserGesture}
      onTouchStart={handleUserGesture}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleUserGesture();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Enter portfolio"
    >
      <div className={`netflix-logo-shell ${isMounted ? 'animate' : ''}`}>
        <img src={logoImage} alt="Sarthak Singh" className="netflix-logo" />
      </div>
    </div>
  );
};

export default NetflixTitle;
